export default class NaicsCodesDropdown {
  constructor() {
    this.sectors = [
      { value: '', text: '' },
      { value: '722511', text: 'Restaurant' },
      { value: '4451', text: 'Grocery Store' },
      { value: '455219', text: 'General Merchandise Stores' },
      { value: '811121', text: 'Autobody Shop' },
      { value: '8111', text: 'General Automotive Repair & Maintenance' },
      { value: '812320', text: 'Dry Cleaner' },
      { value: '812310', text: 'Laundromat' },
      { value: '457', text: 'Gasoline Stations, Convenience Stores and Fuel Dealers' },
      { value: '3315', text: 'Foundries' },
      { value: '332', text: 'Fabricated Metal Product Manufacturing' },
      { value: '332813', text: 'Metal Finisher' },
      { value: '522', text: 'Financial Institutions' },
      { value: '325', text: 'Chemical Manufacturing' },
      { value: '339', text: 'Miscellaneous Manufacturing' },
      { value: '441', text: 'Motor Vehicle and Parts Dealers' },
      { value: '311', text: 'Food and Beverage Manufacturing' },
      { value: '323', text: 'Printing and Related Support Activities' },
      { value: '493', text: 'Warehousing and Storage' },
      { value: '51821', text: 'Data Processing, Hosting, and Related Services' },
      { value: '721', text: 'Accommodation' },
      { value: '333', text: 'Machinery Manufacturing' },
      { value: '484', text: 'Transportation' },
      { value: '326', text: 'Plastics and Rubber Products Manufacturing subsector' },
      { value: '236', text: 'Construction' },
      { value: '325510', text: 'Paint and Coating Manufacturing' },
      { value: '456', text: 'Health and Personal Care' },
      { value: '541', text: 'Professional, Scientific, and Technical Services' },
      { value: '813', text: 'Religious, Grantmaking, Civic, Professional' },
      { value: '327310', text: 'Cement or Asphalt Manufacturing' },
      { value: '00000', text: 'Other (Describe)' },
    ];
    this.subsectors = [
      { sector: '11', value: '111', text: 'Crop Production' },
      { sector: '11', value: '112', text: 'Animal Production and Aquaculture' },
      { sector: '11', value: '113', text: 'Forestry and Logging' },
      { sector: '11', value: '114', text: 'Fishing, Hunting, and Trapping' },
      { sector: '11', value: '115', text: 'Support Activities for Agriculture and Forestry' },
      { sector: '21', value: '211', text: 'Oil and Gas Extraction' },
      { sector: '21', value: '212', text: 'Mining (Except Oil and Gas)' },
      { sector: '21', value: '213', text: 'Support Activities for Mining' },
      { sector: '22', value: '221', text: 'Utilities' },
      { sector: '23', value: '236', text: 'Contruction of Buildings' },
      { sector: '23', value: '237', text: 'Heavy and Civil Engineering Construction' },
      { sector: '23', value: '238', text: 'Specialty Trade Contractors' },
      { sector: '31', value: '311', text: 'Food Manufacturing' },
      { sector: '31', value: '312', text: 'Beverage and Tobacco Product Manufacturing' },
      { sector: '31', value: '313', text: 'Textile Mills' },
      { sector: '31', value: '314', text: 'Textile Product Mills' },
      { sector: '31', value: '315', text: 'Apparel Manufacturing' },
      { sector: '31', value: '316', text: 'Leather and Allied Product Manufacturing' },
      { sector: '31', value: '321', text: 'Wood Product Manufacturing' },
      { sector: '31', value: '322', text: 'Paper Manufacturing' },
      { sector: '31', value: '323', text: 'Printing and Related Support Activities' },
      { sector: '31', value: '324', text: 'Petroleum and Coal Products Manufacturing' },
      { sector: '31', value: '325', text: 'Chemical Manufacturing' },
      { sector: '31', value: '326', text: 'Plastics and Rubber Products Manufacturing' },
      { sector: '31', value: '327', text: 'Nonmetallic Mineral Product Manufacturing' },
      { sector: '31', value: '331', text: 'Primary Metal Manufacturing' },
      { sector: '31', value: '332', text: 'Fabricated Metal Product Manufacturing' },
      { sector: '31', value: '333', text: 'Machinery Manufacturing' },
      { sector: '31', value: '334', text: 'Computer and Electronic Product Manufacturing' },
      { sector: '31', value: '335', text: 'Electrical Equipment, Appliance, and Component Manufacturing' },
      { sector: '31', value: '336', text: 'Transportation Equipment Manufacturing' },
      { sector: '31', value: '337', text: 'Furniture and Related Product Manufacturing' },
      { sector: '31', value: '339', text: 'Miscellaneous Manufacturing' },
      { sector: '42', value: '423', text: 'Merchant Wholesalers, Durable Goods' },
      { sector: '42', value: '424', text: 'Merchange Wholesalers, Nondurable Goods' },
      { sector: '42', value: '425', text: 'Wholesale Trade Agents and Brokers' },
      { sector: '44', value: '441', text: 'Motor Vehicle and Parts Dealers' },
      { sector: '44', value: '444', text: 'Building Material and Garden Equipment and Supplies Dealers' },
      { sector: '44', value: '445', text: 'Food and Beverage Retailers' },
      { sector: '44', value: '449', text: 'Furniture, Home Furnishings, Electronics, and Appliance Retailers' },
      { sector: '44', value: '455', text: 'General Merchandise Retailers' },
      { sector: '44', value: '456', text: 'Health and Personal Care Retailers' },
      { sector: '44', value: '457', text: 'Gasoline Stations and Fuel Dealers' },
      { sector: '44', value: '458', text: 'Clothing, Clothing Accessories, Shoe and Jewelry Retailers' },
      { sector: '44', value: '459', text: 'Sporting Goods, Hobby, Musical Instrument, Book, and Miscellaneous Retailers' },
      { sector: '48', value: '481', text: 'Air Transportation' },
      { sector: '48', value: '482', text: 'Rail Transportation' },
      { sector: '48', value: '483', text: 'Water Transportation' },
      { sector: '48', value: '484', text: 'Truck Transportation' },
      { sector: '48', value: '485', text: 'Transit and Ground Passenger Transportation' },
      { sector: '48', value: '486', text: 'Pipeline Transportation' },
      { sector: '48', value: '487', text: 'Scenic and Sightseeing Transportation' },
      { sector: '48', value: '488', text: 'Support Activities for Transportation' },
      { sector: '48', value: '491', text: 'Postal Service' },
      { sector: '48', value: '492', text: 'Couriers and Messengers' },
      { sector: '48', value: '493', text: 'Warehousing and Storage' },
      { sector: '51', value: '512', text: 'Motion Picture and Sound Recording Industries' },
      { sector: '51', value: '513', text: 'Publishing Industries' },
      { sector: '51', value: '516', text: 'Broadcasting and Content Providers' },
      { sector: '51', value: '517', text: 'Telecommunications' },
      { sector: '51', value: '518', text: 'Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services' },
      { sector: '51', value: '519', text: 'Web Search Portals, Libraries, Archives, and Other Information Services' },
      { sector: '52', value: '521', text: 'Monetary Authorities - Central Bank' },
      { sector: '52', value: '522', text: 'Credit Intermediation and Related Activities' },
      { sector: '52', value: '523', text: 'Securities, Commodity Contracts, and Other Financial Investments and Related Activities' },
      { sector: '52', value: '524', text: 'Insurance Carriers and Related Activities' },
      { sector: '52', value: '525', text: 'Funds, Trusts, and Other Financial Vehicles' },
      { sector: '53', value: '531', text: 'Real Estate' },
      { sector: '53', value: '532', text: 'Rental and Leasing Services' },
      { sector: '53', value: '533', text: 'Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)' },
      { sector: '54', value: '541', text: 'Professional, Scientific, and Technical Services' },
      { sector: '55', value: '551', text: 'Management of Companies and Enterprises' },
      { sector: '56', value: '561', text: 'Administrative and Support Services' },
      { sector: '56', value: '562', text: 'Waste Management and Remediation Services' },
      { sector: '61', value: '611', text: 'Educational Services' },
      { sector: '62', value: '621', text: 'Ambulatory Health Care Services' },
      { sector: '62', value: '622', text: 'Hospitals' },
      { sector: '62', value: '623', text: 'Nursing and Residential Care Facilities' },
      { sector: '62', value: '624', text: 'Social Assistance' },
      { sector: '71', value: '711', text: 'Performing Arts, Spectator Sports, and Related Industries' },
      { sector: '71', value: '712', text: 'Museums, Historical Sites, and Similar Institutions' },
      { sector: '71', value: '713', text: 'Amusement, Gambling and Recreation Industries' },
      { sector: '72', value: '721', text: 'Accommodation' },
      { sector: '72', value: '722', text: 'Food Services and Drinking Places' },
      { sector: '81', value: '811', text: 'Repair and Maintenance' },
      { sector: '81', value: '812', text: 'Personal and Laundry Services' },
      { sector: '81', value: '813', text: 'Religious, Grantmaking, Civic, Professional, and Similar Organizations' },
      { sector: '81', value: '814', text: 'Private Households' },
      { sector: '92', value: '921', text: 'Executive, Legislative, and Other General Government Support' },
      { sector: '92', value: '922', text: 'Justice, Public Order, and Safety Activities' },
      { sector: '92', value: '923', text: 'Administration of Human Resource Programs' },
      { sector: '92', value: '924', text: 'Administration of Environmental Quality Programs' },
      { sector: '92', value: '925', text: 'Administration of Housing Programs, Urban Planning, and Community Development' },
      { sector: '92', value: '926', text: 'Administration of Economic Programs' },
      { sector: '92', value: '927', text: 'Space Research and Technology' },
      { sector: '92', value: '928', text: 'National Security and International Affairs' },
    ];
  }
}
